// import React, { useEffect, useState } from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import ProjectCard from "./ProjectCards";
// import Particle from "../Particle";
// // import data from "./data.json";
// import axios from "axios";

// function Projects() {
//   const [projects, setProjects] = useState([]);

//   useEffect(() => {
//     const datagen = async () =>{
//       const data = await axios.get('https://portfolio-server-91pj.onrender.com/getall')
//       setProjects(data.data);
//     }
//     datagen();
    
//   }, []);

//   if(projects.length==0){
//     return(<Container fluid className="project-section  lodingclass">
//       <Container>
//         <h1 className="project-heading">
//           My Recent <strong className="purple">Works are Loding....</strong>
//         </h1>
//         <div id="preloader"></div>
//       </Container>
//       </Container>)
//   }
//   return (
//     <Container fluid className="project-section">
//               <Particle />

//       <Container>
//         <h1 className="project-heading">
//           My Recent <strong className="purple">Works </strong>
//         </h1>
//         <p style={{ color: "white" }}>
//           Here are a few projects I've worked on recently.
//         </p>
//         <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
//           {projects.map((project, idx) => (
//             <Col md={4} className="project-card" key={idx}>
//               <ProjectCard
//                 imgPath={project.imgPath}
//                 isBlog={project.isBlog}
//                 title={project.title}
//                 description={project.description}
//                 ghLink={project.ghLink}
//                 demoLink={project.demoLink}
//               />
//             </Col>
//           ))}
//         </Row>
//       </Container>
//     </Container>
//   );
// }

// export default Projects;


import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import ProjectCardSkeleton from "./ProjectCardSkeleton";
import Particle from "../Particle";
import axios from "axios";

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const datagen = async () => {
      try {
        const data = await axios.get('https://portfolio-server-91pj.onrender.com/getall');
        setProjects(data.data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      }
    };
    datagen();
  }, []);

  const isLoading = projects.length === 0;

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works</strong>
          {isLoading && <span> are Loading...</span>}
        </h1>
        <p style={{ color: "white" }}>
          {isLoading ? "Fetching projects..." : "Here are a few projects I've worked on recently."}
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {isLoading
            ? Array.from({ length: 3 }).map((_, idx) => (
                <Col md={4} key={idx}>
                  <ProjectCardSkeleton />
                </Col>
              ))
            : projects.map((project, idx) => (
                <Col md={4} className="project-card" key={idx}>
                  <ProjectCard
                    imgPath={project.imgPath}
                    isBlog={project.isBlog}
                    title={project.title}
                    description={project.description}
                    ghLink={project.ghLink}
                    demoLink={project.demoLink}
                  />
                </Col>
              ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
